var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 0L0.666748 16L11.3334 21.8133V37.8133L30.0001 48L48.6667 37.8133V21.8133L54.0001 18.9067V37.3333H59.3334V16L30.0001 0ZM48.1867 16L30.0001 25.92L11.8134 16L30.0001 6.08L48.1867 16ZM43.3334 34.64L30.0001 41.92L16.6667 34.64V24.72L30.0001 32L43.3334 24.72V34.64Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat);
export default __webpack_public_path__ + "static/media/hat.6360e8f9b4c2d0a548b76c157091185b.svg";
export { ForwardRef as ReactComponent };